import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { NavService } from './../navigation/navigation.service';
import { CVFormService } from './../coverage-form.service';
import { FormCustomerInformationService } from './../form-customer-information/form-customer-information.service';
import { FormVehiclesInformationService } from './../form-vehicles-information/form-vehicles-information.service';
import { FormDriverInformationService } from './../form-driver-information/form-driver-information.service';
import { FormMotorCarrierInformationService } from './../form-motor-carrier-information/form-motor-carrier-information.service';

import {
  BobtailStore,
  UPDATE_STORE
} from './../../shared/index';

@Component({
  selector: 'pax-cf-form-application-summary',
  template: require('./form-application-summary.component.html'),
  providers: [FormCustomerInformationService,
    FormVehiclesInformationService,
    FormDriverInformationService,
    FormMotorCarrierInformationService
    ]
})
export class FormApplicationSummaryComponent implements OnInit {
  storeData;
  routeData;
  formApplicationSummary: FormGroup;
  asCustomerInfo;
  arrayCustomerInfo = [];
  arrayVehiclesInfoTruck = [];
  arrayVehiclesInfoTrailer = [];
  arrayDriverInfo = [];
  arrayDriverInfoAccidentViolation = [];
  arrayDriverInfoInsured = [];
  arrayDriverInfoClaims = [];
  singleDriverInfoCurrentlyInsured = {};
  getQuestionOtherTrailerType;
  getQuestionOtherNoInsurance;
  arrayMotorCarrierInfo = [];
  asVehiclesInfo;
  asDriverInfo;
  asMotorCarrierInfo;
  formSubmitted = false;

  constructor(
    private _store: Store<any>,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cv: CVFormService,
    private _fci: FormCustomerInformationService,
    private _fvi: FormVehiclesInformationService,
    private _fdi: FormDriverInformationService,
    private _fmci: FormMotorCarrierInformationService,
    private _ns: NavService
  ) {}

  ngOnInit() {
    // resolve router data
    this.routeData = this._route.data.subscribe((data) => {
      this._store.dispatch({ type: UPDATE_STORE, payload: { steps: data['forms'][1], settings: data['forms'][0] } });
    });


    this.formApplicationSummary = new FormGroup({});
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      this.asCustomerInfo = store.steps['customer-information'];
      this.asVehiclesInfo = store.steps['vehicles-information'];
      this.asDriverInfo = store.steps['driver-information'];
      this.asMotorCarrierInfo = store.steps['motor-carrier-information'];
    });

    // Customer information
    this.arrayCustomerInfo = this._fci.getQuestions().map(this.formatQuestion, this.asCustomerInfo);

    // Vehicles information
    this.arrayVehiclesInfoTruck = this._fvi.getTruckInfo().map(this.formatQuestion, this.asVehiclesInfo['truck']);
    if (this.asVehiclesInfo['trailer']) {
      this.arrayVehiclesInfoTrailer = this._fvi.getTrailerInfo();
      if (this.asVehiclesInfo['trailer']['trailerOtherType']) {
        this.getQuestionOtherTrailerType = this._fvi.getQuestionOtherTrailerType();
        this.arrayVehiclesInfoTrailer.splice((this.getQuestionOtherTrailerType.order - 1), 0, this.getQuestionOtherTrailerType);
      }
      this.arrayVehiclesInfoTrailer = this.arrayVehiclesInfoTrailer.map(this.formatQuestion, this.asVehiclesInfo['trailer']);
    }

    // Driver information
    this.arrayDriverInfo = this._fdi.getQuestions().map(this.formatQuestion, this.asDriverInfo);
    this.singleDriverInfoCurrentlyInsured = this.arrayDriverInfo.pop();
    if (this.asDriverInfo['arrayAccidentViolation']) {
      this.asDriverInfo['arrayAccidentViolation'].forEach(a => {
        this.arrayDriverInfoAccidentViolation.push(this._fdi.getAccidentQuestion().map(this.formatQuestion, a));
      });
    }
    if (this.asDriverInfo['areYouCurrentlyInsured']) {
      this.arrayDriverInfoInsured = this._fdi.getCurrentlyInsured().map(this.formatQuestion, this.asDriverInfo['currentlyInsured']);
      if (this.asDriverInfo['arrayClaims']) {
        this.asDriverInfo['arrayClaims'].forEach(a => {
          this.arrayDriverInfoClaims.push(this._fdi.getClaimsQuestions().map(this.formatQuestion, a));
        });
      }
    } else {
      this.arrayDriverInfoInsured = this._fdi.getCurrentlyNotInsured();
      if (this.asDriverInfo['currentlyInsured']['noPriorInsuranceOther']) {
        this.getQuestionOtherNoInsurance = this._fdi.getQuestionOtherReasonForNoPriorInsurance();
        this.arrayDriverInfoInsured.push(this.getQuestionOtherNoInsurance);
      }
      this.arrayDriverInfoInsured = this.arrayDriverInfoInsured.map(this.formatQuestion, this.asDriverInfo['currentlyInsured']);
    }

    // Motor Carrier information
    this.arrayMotorCarrierInfo = this._fmci.getQuestions().map(this.formatQuestion, this.asMotorCarrierInfo);

  }

  formatQuestion(q) {
    let question = { label: q.label };
    question['value'] = (() => {
      if (q.controlType === 'radio' || q.controlType === 'dropdown' || q.controlType === 'radio') {
        return q.options.reduce((p, n) => {
          if (p) { return p; }
          return p = n['key'] === this[q.key] ? n['value'] : null;
        }, null);
      } else if (q.controlType === 'datepicker') {
        return this[q.key]['formatted'];
      } else {
        return this[q.key];
      }
    })();
    return question;
  }

  onSubmit() {
    this.formSubmitted = true;

    this._cv.sendToServerAndUpdateStore('application-summary', true)
    .then(() => {
      this._ns.manualActiveStep('review-coverage');
      this._router.navigate(['']);
    })
    .catch(err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-application-summary/form-application-summary.component.ts